import { useEffect, useState } from 'react';
import { getTerminalInfo } from '../services/TerminalService';

/**
 * What the terminal endpoint says for this project (services/TerminalService.js), asked once per project; null while
 * it is asked, when it fails, or when `enabled` is false (a viewer: never asked).
 */
export default function useTerminalAccess(projectId, enabled = true) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    setInfo(null);
    if (!enabled || !projectId) { return undefined; }
    let alive = true;
    getTerminalInfo(projectId).then((answer) => {
      if (alive) { setInfo(answer); }
    });
    return () => { alive = false; };
  }, [projectId, enabled]);
  return info;
}
